"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionMapActions = void 0;
var FunctionMapActions;
(function (FunctionMapActions) {
    FunctionMapActions["DISCOUNT_PRICE"] = "PRICE_DISCOUNT";
    FunctionMapActions["DISCOUNT_PERCENT"] = "PERCENT_DISCOUNT";
    FunctionMapActions["SURCHARGE_PRICE"] = "PRICE_SURCHARGE";
    FunctionMapActions["SURCHARGE_PERCENT"] = "PERCENT_SURCHARGE";
    FunctionMapActions["UPDATE_PRICE"] = "UPDATE_PRICE_MAP";
    FunctionMapActions["ORDER_RECEIPT"] = "ORDER_RECEIPT";
    FunctionMapActions["END_SHIFT"] = "END_SHIFT";
    FunctionMapActions["PRINT_SHIFT_SUMMARY"] = "PRINT_SHIFT_SUMMARY";
    FunctionMapActions["MONEY_IN_OUT"] = "MONEY_IN_OUT";
    FunctionMapActions["BACK"] = "BACK";
    FunctionMapActions["ADD_NEW_CUSTOMER"] = "ADD_NEW_CUSTOMER";
    FunctionMapActions["CASH_PAY"] = "CASH_PAY";
    FunctionMapActions["PAY"] = "PAYMENT";
    FunctionMapActions["ADD_NOTE"] = "ADD_NOTE";
    FunctionMapActions["REMOVE_ITEM"] = "REMOVE_ITEM";
    FunctionMapActions["VOID_SALE"] = "VOID_SALE";
    FunctionMapActions["SWITCH_PRICING_GRP"] = "SWITCH_PRICING_GRP";
    FunctionMapActions["PRINT_PREV_RECEIPT"] = "PRINT_PREV_RECEIPT";
    FunctionMapActions["RESEND_TO_KITCHEN"] = "RESEND_TO_KITCHEN";
    FunctionMapActions["HOLD_PRINT"] = "HOLD_PRINT";
    FunctionMapActions["OPEN_TABLE"] = "OPEN_TABLE";
    FunctionMapActions["SYSTEM_LOGOUT"] = "SYSTEM_LOGOUT";
    FunctionMapActions["SWITCH_MENU"] = "SWITCH_MENU";
    FunctionMapActions["OPEN_DRAWER"] = "OPEN_DRAWER";
    FunctionMapActions["ITEM_AVAILABILITY"] = "ITEM_AVAILABILITY";
    FunctionMapActions["SHOW_REWARDS"] = "SHOW_REWARDS";
    FunctionMapActions["SWITCH_COURSE"] = "SWITCH_COURSE";
    FunctionMapActions["REMOVE_DISCOUNTS"] = "REMOVE_DISCOUNTS";
    FunctionMapActions["REMOVE_SURCHARGES"] = "REMOVE_SURCHARGES";
    FunctionMapActions["TRAINING_MODE"] = "TRAINING_MODE";
    FunctionMapActions["PICK_SCHEDULED_PRICE_LIST"] = "PICK_SCHEDULED_PRICE_LIST";
    FunctionMapActions["ADD_VOUCHER"] = "ADD_VOUCHER";
    FunctionMapActions["SCHEDULED_ADJUSTMENTS"] = "SCHEDULED_ADJUSTMENTS";
    FunctionMapActions["TRANSFER_ITEMS"] = "TRANSFER_ITEMS";
})(FunctionMapActions = exports.FunctionMapActions || (exports.FunctionMapActions = {}));
//# sourceMappingURL=functionMaps.js.map